import {
  ACCOUNT_API_CONFIG,
  AUTHENTICATION_API_CONFIG,
  AccountWebservice,
  AlgoliaWebservice,
  AuthenticationWebservice,
  BANKING_PROCESSOR_API_CONFIG,
  BankingPartnerWebservice,
  BankingUserWebservice,
  COMPANY_API_CONFIG,
  CityWebservice,
  ContractWebservice,
  DegreeWebservice,
  EMAIL_API_CONFIG,
  EmailWebservice,
  FIBII_API_CONFIG,
  FibiiOrdersWebservice,
  JOB_API_CONFIG,
  JobWebservice,
  PLACE_API_CONFIG,
  PROFILE_API_CONFIG,
  ProfileWebservice,
  SCHOOL_API_CONFIG,
  SUBSCRIPTION_API_CONFIG,
  SubscriptionWebservice,
  WizCompanyWebservice,
} from '@wizbii-utils/angular/webservices';
import { ALGOLIA_SERVICE_TOKEN } from '@wizbii-utils/angular/algolia';
import { EnvironmentProviders, Provider } from '@angular/core';
import { environment } from '@environment';
import { RECRUITER_API_CONFIG, RecruiterWebservice } from '@ats/webservices';
import { provideNativeDateAdapter } from '@angular/material/core';

export const featuresProviders: (Provider | EnvironmentProviders)[] = [
  provideNativeDateAdapter(),
  AlgoliaWebservice,
  {
    provide: AUTHENTICATION_API_CONFIG,
    useValue: {
      appId: environment.applicationId,
      baseUrl: environment.api.authentication,
    },
  },
  {
    provide: ALGOLIA_SERVICE_TOKEN,
    useValue: {
      applicationId: environment.algolia.applicationId,
      apiKey: environment.algolia.apiKey,
      options: {},
    },
  },
  AuthenticationWebservice,
  {
    provide: PLACE_API_CONFIG,
    useValue: {
      baseUrl: environment.api.place,
    },
  },
  CityWebservice,
  AccountWebservice,
  {
    provide: ACCOUNT_API_CONFIG,
    useValue: {
      appId: environment.applicationId,
      baseUrl: environment.api.account,
      baseUrlHost: environment.host.account,
      locale: environment.locale,
    },
  },
  SubscriptionWebservice,
  {
    provide: SUBSCRIPTION_API_CONFIG,
    useValue: {
      baseUrl: environment.api.subscription,
    },
  },
  ProfileWebservice,
  {
    provide: PROFILE_API_CONFIG,
    useValue: {
      baseUrl: environment.api.profile,
    },
  },
  EmailWebservice,
  {
    provide: EMAIL_API_CONFIG,
    useValue: {
      baseUrl: environment.api.email,
    },
  },
  WizCompanyWebservice,
  {
    provide: COMPANY_API_CONFIG,
    useValue: {
      baseUrl: environment.api.company,
    },
  },
  RecruiterWebservice,
  {
    provide: RECRUITER_API_CONFIG,
    useValue: {
      baseUrl: environment.api.recruiter,
    },
  },
  JobWebservice,
  ContractWebservice,
  {
    provide: JOB_API_CONFIG,
    useValue: {
      baseUrl: environment.api.job,
    },
  },
  DegreeWebservice,
  {
    provide: SCHOOL_API_CONFIG,
    useValue: {
      appId: environment.applicationId,
      baseUrl: environment.api.school,
    },
  },
  BankingPartnerWebservice,
  BankingUserWebservice,
  {
    provide: BANKING_PROCESSOR_API_CONFIG,
    useValue: {
      baseUrl: environment.api.bankingProcessor,
      locale: environment.locale,
    },
  },
  FibiiOrdersWebservice,
  {
    provide: FIBII_API_CONFIG,
    useValue: {
      baseUrl: environment.api.fibii,
    },
  },
];
